import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import InboxIcon from '@mui/icons-material/Inbox';

interface Props {
  hasSection?: boolean;
}

export default function EmptyState({ hasSection = false }: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 12,
        px: 3,
        textAlign: 'center',
      }}
    >
      {hasSection ? (
        <>
          <InboxIcon
            sx={{ fontSize: 48, color: 'text.disabled', mb: 2 }}
          />
          <Typography variant="h4" color="text.primary" gutterBottom>
            No content yet
          </Typography>
          <Typography variant="body1" color="text.secondary" maxWidth={360}>
            Click + Add to get started.
          </Typography>
        </>
      ) : (
        <>
          <FolderOpenIcon
            sx={{ fontSize: 48, color: 'text.disabled', mb: 2 }}
          />
          <Typography variant="h4" color="text.primary" gutterBottom>
            Select a section
          </Typography>
          <Typography variant="body1" color="text.secondary" maxWidth={360}>
            Choose a section from the sidebar to browse content.
          </Typography>
        </>
      )}
    </Box>
  );
}
